module.exports = __webpack_public_path__ + "img/statistics.d90481ca.svg";